import useIsMobile from '@/hooks/useIsMobile';
import OrderGeneralCardDesktop from './desktop';
import OrderGeneralCardMobile from './mobile';

const OrderGeneralCard = () => {
    const isMobile = useIsMobile(992);

    return isMobile ? <OrderGeneralCardMobile /> : <OrderGeneralCardDesktop />;
};

export default OrderGeneralCard;
